export interface FilterCondition {
  field: string;
  operator: string;
  value: string;
}

export type FilterState = Record<string, any>;

export function convertArrayToObject(conditions: FilterCondition[]): FilterState {
  const result: FilterState = {};

  conditions.forEach(cond => {
    result[cond.field] = `${cond.operator}|${cond.value}`;
  });

  return result;
}

export function convertObjectToArray(filters: FilterState = {}): FilterCondition[] {
  return Object.entries(filters).map(([field, raw]) => {
    if (typeof raw !== "string" || !raw.includes("|")) {
      return { field, operator: "=", value: String(raw) };
    }

    const [operator, value] = raw.split("|");

    return { field, operator, value };
  });
}
